export class MeasureUnitConfig {
  static defaultConfig = new MeasureUnitConfig();

  /**
   * Deicalmal places to show. If not given a default value
   */
  decimalPlaces?: number;

  hasSign?: boolean;

  shortenThousands?: boolean;

  refValue?: number;

  removeDecimalZeros?: boolean;

  isDiff?: boolean;
}
